// Site-level config sourced from env at build time.
//
// All values fall back to the original hardcoded defaults so the site keeps
// working when the env file is missing (e.g. fresh checkout, CI).

function envOrDefault(envKey: string, fallback: string): string {
  const v = (import.meta.env[envKey as keyof ImportMetaEnv] as string | undefined)?.trim()
  return v && v.length > 0 ? v : fallback
}

function envMaybe(envKey: string): string | undefined {
  const v = (import.meta.env[envKey as keyof ImportMetaEnv] as string | undefined)?.trim()
  return v && v.length > 0 ? v : undefined
}

export const siteConfig = {
  /**
   * Canonical site origin (no trailing slash). Used for canonical URLs,
   * hreflang alternates, JSON-LD @id/url, and absolute OG image URLs. The
   * production domain is helinhair.dk (NOT .com).
   */
  origin: envOrDefault('VITE_SITE_ORIGIN', 'https://helinhair.dk'),
  contact: {
    email: envOrDefault('VITE_CONTACT_EMAIL', 'info@helinhair.dk'),
  },
  /**
   * The legal seller, shown in the footer and the terms of sale. Danish e-commerce law requires
   * a geographic address and a phone number; we give the Værløse salon's (keep
   * in step with its entry in config/salons.ts). The terms page leaves out a
   * line while it is empty.
   */
  company: {
    name: 'Helin Hair ApS',
    cvr: '36955317',
    address: 'Bymidten 40, DK-3500 Værløse',
    phone: '+45 26 25 92 92',
  },
  social: {
    // Empty values cause the icon to be hidden.
    instagram: envMaybe('VITE_SOCIAL_INSTAGRAM_URL') ?? 'https://www.instagram.com/helinhair.dk',
    facebook: envMaybe('VITE_SOCIAL_FACEBOOK_URL') ?? 'https://www.facebook.com/helinhair.old',
    tiktok: envMaybe('VITE_SOCIAL_TIKTOK_URL') ?? 'https://www.tiktok.com/@helinhair.dk',
    youtube: envMaybe('VITE_SOCIAL_YOUTUBE_URL') ?? 'https://www.youtube.com/@helinhair',
  },
} as const

export function getSocialLinks() {
  return [
    { key: 'instagram' as const, url: siteConfig.social.instagram },
    { key: 'facebook' as const, url: siteConfig.social.facebook },
    { key: 'tiktok' as const, url: siteConfig.social.tiktok },
    { key: 'youtube' as const, url: siteConfig.social.youtube },
  ].filter((s) => s.url && s.url.length > 0)
}
